import { LicenseName } from "@/data/license.data";
import { IsDatasetLimitedResult } from "@/services/license/base/license-manager-abstractions";
import { LimiterWithUniqueLimits } from "@/services/license/license-limiters/base-limiters/limiter-with-unique-limits";

export abstract class DatasetSizeLimiter extends LimiterWithUniqueLimits {
  async isDatasetSizeLimited(
    userId: string,
    license: LicenseName,
    fileBytesSize: number,
  ): Promise<IsDatasetLimitedResult> {
    const datasetSizeLimit = await this.getLimit(userId, license);
    const maxBytesSize = datasetSizeLimit * 1024 * 1024; // convert to bytes.

    return {
      isLimited: fileBytesSize >= maxBytesSize,
      limit: datasetSizeLimit,
    };
  }
}
